export default {
  maxCountOfPaymentMethods: 9,
  maxCountOfShippingAdresses: 5,
}
